import React, {useEffect, useRef, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import {motion} from "framer-motion";
import "./NavBar.scss";

const NavBar = () => {
    const [hidden, setHidden] = useState(false);
    const lastScrollY = useRef(0);
    const location = useLocation();

    // react-router doesn't scroll or re-render anything if you click a Link
    // to the route you're already on - so clicking Home while already on "/"
    // otherwise does nothing at all.
    const handleBrandClick = (e) => {
        if (location.pathname === '/') {
            e.preventDefault();
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    };

    useEffect(() => {
        lastScrollY.current = window.scrollY;

        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const scrolledDown = currentScrollY > lastScrollY.current;
            const pastThreshold = currentScrollY > 80;

            setHidden(scrolledDown && pastThreshold);
            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, {passive: true});
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <motion.nav
            className="navbar"
            animate={{y: hidden ? "-100%" : "0%"}}
            transition={{duration: 0.35, ease: "easeInOut"}}
        >
            <div className="navbar-inner">
                <Link to="/" className="navbar-brand" aria-label="Home" onClick={handleBrandClick}>
                    {/* Cloud path is identical between the plain and
                        sun-out reference icons, so the hover effect is a
                        reveal of the extra sun path (sliding in from the
                        right, from behind the cloud), not a true path
                        morph - see .navIconSun in NavBar.scss. */}
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="38" height="38" className="navIcon">
                        <path
                            className="navIconSun"
                            d="M11.0004 4C10.0882 2.78555 8.63582 2 7 2C4.23858 2 2 4.23858 2 7C2 9.05032 3.2341 10.8124 5 11.584"
                            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                        />
                        <path
                            d="M14.381 9.02721C14.9767 8.81911 15.6178 8.70588 16.2857 8.70588C16.9404 8.70588 17.5693 8.81468 18.1551 9.01498M7.11616 11.6089C6.8475 11.5567 6.56983 11.5294 6.28571 11.5294C3.91878 11.5294 2 13.4256 2 15.7647C2 18.1038 3.91878 20 6.28571 20H16.2857C19.4416 20 22 17.4717 22 14.3529C22 11.8811 20.393 9.78024 18.1551 9.01498M7.11616 11.6089C6.88706 10.9978 6.7619 10.3369 6.7619 9.64706C6.7619 6.52827 9.32028 4 12.4762 4C15.4159 4 17.8371 6.19371 18.1551 9.01498M7.11616 11.6089C7.68059 11.7184 8.20528 11.9374 8.66667 12.2426"
                            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                        />
                    </svg>
                    <span className="sr-only">Home</span>
                </Link>
                <ul className="navbar-list">
                    <li>
                        <HashLink to="/#work" className="navbar-link">
                            Work
                        </HashLink>
                    </li>
                    <li>
                        <Link to="/about" className="navbar-link">
                            About
                        </Link>
                    </li>
                    <li>
                        <a
                            href="/SSchmidtResume.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="navbar-resume"
                        >
                            Resume
                        </a>
                    </li>
                </ul>
            </div>
        </motion.nav>
    );
};

export default NavBar;
